import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templatePhasrRecommendationSideMenu = document.createElement('template');

templatePhasrRecommendationSideMenu.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='content-wrapper'>
      <div class="header mt-6 mb-1">
          <gz-title id="menuTitle" class="mb-2" fontsize="16" fontweight="500"></gz-title>
      </div>
      <div class="panel-content">
        <div id="general-section">
          <gz-title
              id="general-title"
              fontSize="${FontSizes.PARAGRAPH_11}"
              fontWeight="${FontWeights.SEMIBOLD}"
              class="section-title text-uppercase mb-2"
              >
           </gz-title>
          <gz-labeled-content id="targeted-activity-type"></gz-labeled-content>
          <gz-labeled-content id="attack-surface-reduction"></gz-labeled-content>
          <gz-labeled-content id="created-on"></gz-labeled-content>
          <gz-labeled-content id="monitored-rule"></gz-labeled-content>
          <gz-labeled-content id="behavioral-profiles"></gz-labeled-content>
          <gz-labeled-content id="action-taken"></gz-labeled-content>
        </div>
        <div id="details-section">
          <gz-title
              id="details-title"
              fontSize="${FontSizes.PARAGRAPH_11}"
              fontWeight="${FontWeights.SEMIBOLD}"
              class="section-title text-uppercase mb-2"
              >
           </gz-title>
          <gz-text
              id="details-description"
              fontSize="${FontSizes.PARAGRAPH_12}"
              fontWeight="${FontWeights.NORMAL}"
              class="mb-2"
              >
           </gz-text>
        </div>
        <div id="mitigation-section">
          <gz-title
              id="mitigation-title"
              fontSize="${FontSizes.PARAGRAPH_11}"
              fontWeight="${FontWeights.SEMIBOLD}"
              class="section-title text-uppercase mb-2"
              >
           </gz-title>
          <gz-text
              id="mitigation-text"
              fontSize="${FontSizes.PARAGRAPH_12}"
              fontWeight="${FontWeights.NORMAL}"
              class="mb-2"
              >
           </gz-text>
        </div>
      </div>
      <div class='bottom-buttons'>
        <gz-button id='apply-button'></gz-button>
        <gz-button id='restrict-access'></gz-button>
        <div class='flex-auto'></div>
      </div>
    </div>
  </div>
  <gz-side-menu id='behavioralProfilesPanel' menuwidth='400' closeOnClickOutside>
  </gz-side-menu>
`;
